import React from "react";
import { Table } from "reactstrap";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";

const PrintView = ({ data, totalTransactionCount }) => {
  // Calculate totals
  const totalQuantity = data?.reduce(
    (sum, item) => sum + item.totalQuantity,
    0
  );
  const totalAmount = data?.reduce((sum, item) => sum + item.totalAmount, 0);
  return (
    <div className="d-none d-print-block">
      <Table striped bordered>
        <thead>
          <tr>
            <th>S.N</th>
            <th>Transaction Type</th>
            <th>Total Quantity</th>
            <th className="text-end">Total Amount</th>
            <th>Transaction Count</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td className="fw-bold">{item.type}</td>
              <td>{item.totalQuantity}</td>
              <td className="text-end">
                <NumberCommas number={item.totalAmount} />
              </td>
              <td>{item.transactionCount}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td className="fw-bold">Total</td>
            <td className="fw-bold">{totalQuantity}</td>
            <td className="text-end fw-bold">
              <NumberCommas number={totalAmount} />
            </td>
            <td className="fw-bold">{totalTransactionCount}</td>
          </tr>
        </tfoot>
      </Table>
    </div>
  );
};

export default PrintView;
